import React from "react";
import { Link } from "react-router-dom";

const skills = [
  { label: "React / React Native", level: 85 },
  { label: "Node.js / Express", level: 80 },
  { label: "MongoDB / MySQL", level: 75 },
  { label: "Arduino / ESP32 (IoT)", level: 90 },
  { label: "Java / Android", level: 80 },
  { label: "Python", level: 70 },
];

const timeline = [
  { year: "2024", title: "CrashGuard", desc: "Accident detection app using ESP32 sensors + SMS alerts." },
  { year: "2024", title: "E-Commerce App", desc: "Full-stack online store with cart, payments, and admin panel." },
  { year: "2023", title: "Construction App", desc: "Project management tool for construction teams on Android." },
  { year: "2023", title: "Ariyom Tech Founded", desc: "Started building apps to solve everyday problems." },
];

export default function About() {
  return (
    <div style={{ paddingTop: 100 }}>
      <div className="container" style={{ paddingBottom: 80 }}>

        {/* Header */}
        <div style={{ maxWidth: 640, marginBottom: 60 }}>
          <p style={{ color: "var(--accent)", fontWeight: 600, fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>
            About Us
          </p>
          <h1 className="section-title">We Learn. We Build. We Innovate.</h1>
          <p style={{ color: "var(--muted)", fontSize: 16, lineHeight: 1.8, marginTop: 20 }}>
            Ariyom Tech Solutions is a startup focused on building real, useful apps — from accident detection systems to e-commerce platforms. We combine hardware, software, and design to create solutions that matter.
          </p>
        </div>

        {/* Skills */}
        <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24 }}>Tech Skills</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 20, marginBottom: 60 }}>
          {skills.map((s) => (
            <div key={s.label} className="card" style={{ padding: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                <span style={{ fontSize: 14, fontWeight: 500 }}>{s.label}</span>
                <span style={{ color: "var(--accent)", fontSize: 13, fontWeight: 600 }}>{s.level}%</span>
              </div>
              <div style={{ background: "var(--border)", borderRadius: 999, height: 6, overflow: "hidden" }}>
                <div style={{
                  width: `${s.level}%`, height: "100%",
                  background: "linear-gradient(90deg, var(--accent), var(--accent2))",
                  borderRadius: 999,
                  transition: "width 1s ease",
                }} />
              </div>
            </div>
          ))}
        </div>

        {/* Timeline */}
        <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 28 }}>Our Journey</h2>
        <div style={{ position: "relative", paddingLeft: 32, marginBottom: 60 }}>
          {/* Vertical line */}
          <div style={{ position: "absolute", left: 7, top: 0, bottom: 0, width: 2, background: "var(--border)" }} />

          {timeline.map((item, i) => (
            <div key={i} style={{ position: "relative", marginBottom: 32 }}>
              {/* Dot */}
              <div style={{
                position: "absolute", left: -29, top: 4,
                width: 12, height: 12, borderRadius: "50%",
                background: "var(--accent)", border: "2px solid var(--bg)",
                boxShadow: "0 0 8px var(--accent)",
              }} />
              <span style={{ color: "var(--accent)", fontSize: 12, fontWeight: 600 }}>{item.year}</span>
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: "4px 0" }}>{item.title}</h3>
              <p style={{ color: "var(--muted)", fontSize: 14 }}>{item.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{
          background: "rgba(0,229,255,0.05)",
          border: "1px solid rgba(0,229,255,0.15)",
          borderRadius: 16, padding: "40px 32px",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          flexWrap: "wrap", gap: 20,
        }}>
          <div>
            <h3 style={{ fontSize: 20, fontWeight: 700 }}>Want to work together?</h3>
            <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 4 }}>Let's connect and build something great.</p>
          </div>
          <Link to="/contact" className="btn btn-primary" style={{ textDecoration: "none", padding: "12px 28px" }}>
            Contact Us →
          </Link>
        </div>
      </div>
    </div>
  );
}
